export const CREDITS_PER_UNIT = {
  // per kg
  metalCommon: 10,
  metalRare: 100,
  oreCommon: 5,
  oreRare: 50,
  rock: 0.5,
  gasCommon: 10,
  gasRare: 70,
  ice: 1,
  isotope: 300,
  crystalCommon: 5,
  crystalRare: 70,
  organic: 30,
  // per each
  credit: 1,
  norveliosScrip: 0.3,
  tradeHouseKgDay: 0.03,
  tradeHouseKgMonth: 0.75,
  // same as the source minus transaction fee
  tradeHouseDeposit: 1,
};

// https://en.wikipedia.org/wiki/Abundance_of_the_chemical_elements
